import {
  ColumnLayout,
  Heading,
  Header,
  Section,
  Skeleton,
  Text,
} from "@mittwald/flow-remote-react-components";

export const PageSpeedOptimizerSkeleton = () => {
  return (
    <>
      <Section>
        <Header>
          <Heading>Datenübertragung deiner Website</Heading>
        </Header>
        <ColumnLayout s={[1]} m={[1, 1, 1]} gap="m">
          <Skeleton height="160px" />
        </ColumnLayout>
      </Section>

      <Section>
        <Header>
          <Heading>Komprimierung</Heading>
        </Header>
        <Text>
          GZIP-Komprimierung verkleinert textbasierte Dateien beim Ausliefern um
          60 – 85 %.
        </Text>
        <Skeleton />
      </Section>

      <Section>
        <Header>
          <Heading>Caching</Heading>
        </Header>
        <Text>
          Browser-Caching weist Besucher an, statische Dateien lokal
          zwischenzuspeichern.
        </Text>
        <Skeleton />
      </Section>
    </>
  );
};
